import { WithStyles } from '@material-ui/core';
import Paper from '@material-ui/core/Paper';
import { createStyles, withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import * as React from 'react';
import { connect } from 'react-redux';
import { StaticContext } from 'react-router';
import { RouteComponentProps } from 'react-router-dom';
import { Dispatch } from 'redux';

import { ICurriculum, setCurriculmContentData } from '../actions/imstat';
import { IUserAttr } from '../actions/session';
import { IRootState } from '../reducers';
import i18n from '../resources/i18n';
import ImstatScenarioFactory, {
	IFetchCurriculumContentParam,
} from '../scenario/ImstatScenarioFactory';
import CurriculumContentTable from './CurriculumContentTable';
const styles = (theme: Theme) =>
	createStyles({
		paper: {
			marginTop: theme.spacing(4),
			padding: theme.spacing(3),
		},
		root: {
			flexGrow: 1,
			padding: theme.spacing(3),
		},
	});

// tslint:disable-next-line: no-empty-interface
interface IRouteParams {
	career_id: string;
	cur_type: string;
}

// tslint:disable-next-line: no-empty-interface
interface IRouteState {}

interface IState {
	compulsoryID: string;
	careerTitle: string;
	organizer: string;
	credit: string;
	status: string;
}

/**
 * カリキュラム一覧
 */
class CurriculumContent extends React.Component<IProps, IState> {
	constructor(props: IProps) {
		super(props);

		this.state = {
			careerTitle: '',
			compulsoryID: '',
			credit: '',
			organizer: '',
			status: '',
		};
	}

	/**
	 * componentDidMount
	 */
	public componentDidMount() {
		window.scrollTo({
			top: 0,
		});
		if (!this.props.match || !this.props.match.params) {
			return;
		}

		const careerID = this.props.match.params.career_id;

		if (this.props.match.params.cur_type === '0') {
			// 実施中カリキュラム内容一覧取得
			this.props.fetchOnGoingCurriculumContent(this.props.token, {
				careerID,
				userAttr: this.props.userAttr,
			});
		} else {
			// 実績カリキュラム内容一覧取得
			this.props.fetchResultCurriculumContent(this.props.token, {
				careerID,
				userAttr: this.props.userAttr,
			});
		}

		// カリキュラム一覧からタイトルを探す処理を定義
		const setTitle = (curriculums: ICurriculum[]) => {
			for (const e of curriculums) {
				if (e.careerID === careerID) {
					this.setState({
						careerTitle: e.careerTitle,
						compulsoryID: e.compulsoryID,
						credit: e.credit,
						organizer: e.organizer,
						status: e.status,
					});
					break;
				}
			}
		};
		if (this.props.curriculums.length > 0) {
			// imstatのカリキュラム一覧があればそこから探す
			setTitle(this.props.curriculums);
		} else {
			if (this.props.match.params.cur_type === '0') {
				// 実施中カリキュラム場合、imstatのカリキュラム一覧がない場合は自分で取得してから探す
				this.props
					.doFetchOnGoingCurriculum(
						this.props.token,
						this.props.userAttr
					)
					.then(curriculums => setTitle(curriculums));
			} else {
				// 実績カリキュラム場合、imstatのカリキュラム一覧がない場合は自分で取得してから探す
				this.props
					.doFetchResultCurriculum(
						this.props.token,
						this.props.userAttr
					)
					.then(curriculums => setTitle(curriculums));
			}
		}
	}

	/**
	 * Lifecycle Methods
	 */
	public componentWillUnmount() {
		// データを破棄
		this.props.resetCurriculumContent();
	}

	public render() {
		const { classes, data, selectedColumns } = this.props;

		return (
			<div className={classes.root}>
				<Paper className={classes.paper}>
					<Table>
						<TableHead>
							<TableRow>
								<TableCell padding={'none'}>
									{i18n.t('CurriculumContent_0001')}
								</TableCell>
								<TableCell padding={'none'}>
									{i18n.t('CurriculumContent_0002')}
								</TableCell>
								<TableCell padding={'none'}>
									{i18n.t('CurriculumContent_0003')}
								</TableCell>
								<TableCell padding={'none'}>
									{i18n.t('CurriculumContent_0004')}
								</TableCell>
								<TableCell padding={'none'}>
									{i18n.t('CurriculumContent_0005')}
								</TableCell>
							</TableRow>
						</TableHead>
						<TableBody>
							<TableRow>
								<TableCell padding={'none'}>
									{this.state.compulsoryID}
								</TableCell>
								<TableCell padding={'none'}>
									{this.state.careerTitle}
								</TableCell>
								<TableCell padding={'none'}>
									{this.state.organizer}
								</TableCell>
								<TableCell padding={'none'}>
									{this.state.credit}
								</TableCell>
								<TableCell padding={'none'}>
									{i18n.t(this.state.status, { ns: 'force' })}
								</TableCell>
							</TableRow>
						</TableBody>
					</Table>
				</Paper>
				<Paper className={classes.paper}>
					<CurriculumContentTable
						data={data}
						selectedColumns={selectedColumns}
					/>
				</Paper>
			</div>
		);
	}
}

const mapStateToProps = (state: IRootState) => ({
	curriculums: state.imstat.onGoingCurriculum.data,
	data: state.imstat.curriculumContent.data,
	selectedColumns: state.imstat.curriculumContent.selectedColumns,
	token: state.session.token,
	userAttr: state.session.userAttr,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
	doFetchOnGoingCurriculum: (token: string, userAttr: IUserAttr) => {
		const s = ImstatScenarioFactory.createDoFetchOnGoingCurriculum(
			dispatch,
			token
		);
		return s.run(userAttr);
	},
	doFetchResultCurriculum: (token: string, userAttr: IUserAttr) => {
		const s = ImstatScenarioFactory.createDoFetchResultCurriculum(
			dispatch,
			token
		);
		return s.run(userAttr);
	},
	fetchOnGoingCurriculumContent: (
		token: string,
		arg: IFetchCurriculumContentParam
	) => {
		const s = ImstatScenarioFactory.createFetchOnGoingCurriculumContent(
			dispatch,
			token
		);
		s.run(arg);
	},
	fetchResultCurriculumContent: (
		token: string,
		arg: IFetchCurriculumContentParam
	) => {
		const s = ImstatScenarioFactory.createFetchResultCurriculumContent(
			dispatch,
			token
		);
		s.run(arg);
	},
	resetCurriculumContent: () =>
		dispatch(setCurriculmContentData({ data: [] })),
});

// tslint:disable-next-line: no-empty-interface
export interface ICurriculumContentProps {}

const mergeProps = (
	state: IStateProps,
	events: IDispatchProps,
	ownProps: IOwnProps
) => ({
	...state,
	...events,
	...ownProps,
});

type IStateProps = ReturnType<typeof mapStateToProps>;
type IDispatchProps = ReturnType<typeof mapDispatchToProps>;
type IOwnProps = WithStyles<typeof styles> &
	RouteComponentProps<IRouteParams, StaticContext, IRouteState> &
	ICurriculumContentProps;
type IProps = ReturnType<typeof mergeProps>;

const Connected = connect(
	mapStateToProps,
	mapDispatchToProps,
	mergeProps
)(CurriculumContent);

const Styled = withStyles(styles)(Connected);
const Export: React.ComponentType<ICurriculumContentProps> = Styled;

export default Export;



// WEBPACK FOOTER //
// ./src/containers/CurriculumContent.tsx